// redux-saga
import {call, take, put} from "redux-saga/effects";
// Redux factory
import createFetchRedux from "../createFetchRedux";
// Api configuration
import api from "api";
// Fetch service
import fetch from "services/fetch";
// Redux modules
import {openSnackbar} from "../snackbar/open";

const {reducer, actions, selectors} = createFetchRedux("importProductTemplate");
// Reducer
export default reducer;
// Action types
export const EXPORT_PRODUCT_TEMPLATE = "importProductTemplate/EXPORT_PRODUCT_TEMPLATE";
// Actions
export const fetchExport = actions.fetch;
export const exportData = actions;

export function downloadProductTemplate() {
    return {
        type: EXPORT_PRODUCT_TEMPLATE,
    };
}

export function exportDownload(res) {
    const blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    const anchorEl = document.createElement("a");
    anchorEl.style = "display: none";
    document.body.appendChild(anchorEl);
    const url = window.URL.createObjectURL(blob);
    anchorEl.href = url;
    anchorEl.download = `ProductImportTemplate.xlsx`;
    anchorEl.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(anchorEl);
}

// Selectors
export const selectExportResult = selectors.selectReduxData;
export const selectExportDataLoading = selectors.selectReduxLoading;

// Sagas
export function* watchExportProductImportTemplate() {
    while (true) {
        yield take(EXPORT_PRODUCT_TEMPLATE);
        const {url, type, error} = api["products.export.template.get"]();
        try {
            const result = yield call(fetch, url, type, null, null, null, 'binary');
            yield put(exportData.receive(result));
            yield call(exportDownload, result);
        } catch (e) {
            yield put(exportData.error(error));
            yield put(openSnackbar(error, "error"));
            console.error(e);
        }
    }
}
